
import img0 from './Images/Install_1.png';
import img1 from './Images/Edge_WebView.png';
import img2 from './Images/Download_Error.png';
import img3 from './Images/DotNet_Runtime.png';
import img4 from './Images/DotNet_Runtime_Confirmation.png';
import img5 from './Images/Install_2.png';
import img6 from './Images/Install_3.png';
  
const content = `# Install OnData Encryption Tool

## 1. Install on Windows Operating Systems
The OnData Encryption Tool comes with a \`setup.exe\` and a Microsoft Windows Installer (MSI) for the Windows platform. After obtaining the package from OnData, 
you can extract it and run the \`setup.exe\` inside to install the application. Please note that administrative access to the operating system is required to install 
the OnData Encryption Tool.  
  
Below is the list of steps to install the application on Windows.  
a. Double click on the \`setup.exe\` after extracting the package. The following screen is displayed.  
  
![Welcome Screen](${ img0 })  
  
**Note**: If your computer does not have the Microsoft Edge WebView runtime installed, it may prompt you to install the Edge WebView
runtime component first, as illustrated below. Please select \`Install\` to install the Edge WebView runtime component from Microsoft.  
  
![Edge WebView](${ img1 })  
  
If your Internet security settings are very restrictive, the automated download of the Edge WebView runtime component may fail. Below is
a sample screenshot for that failure.  
  
![Edge WebView Download Error](${ img2 })  
  
In that case, please visit [this link](http://go.microsoft.com/fwlink/p/?LinkId=2124703) directly to download and install the Edge WebView
runtime component. After that, please click on the "Cancel" button to exit the OnData Encryption Tool Setup, and double click on the
setup.exe again to proceed with the installation.  

**Note**: If your computer does not have the Microsoft .NET Runtime 8.x installed, it may prompt you to install the .NET Desktop Runtime 8.x
component first, as illustrated below. Please select \`Install\` to install the .NET Desktop Runtime 8.x component from Microsoft.  
  
![.NET Desktop Runtime](${ img3 })  
  
The system may prompt you to confirm the installation of the .NET Desktop Runtime. Please select "Yes" to confirm.  
  
![.NET Desktop Runtime Confirmation](${ img4 })  

Once the .NET Desktop Runtime is installed, the installer will continue with the steps below to install the OnData Encryption Tool.

b. Click on Next and select a folder where the application should be installed. It is recommended to use the default path.  
  
![Installation Folder](${ img5 })  

c. Click on Next and Next again to confirm the installation. You will be prompted to allow the installer to make changes to your system. The screen will display OnData as the software publisher.  
  
![Confirmation](${ img6 })  

d. Select Yes to proceed with the installation. Wait till the installation to complete. After the installation is finished,
click on the Close button to exit the installation process. A shortcut to the OnData Encryption Tool is placed on the desktop.

## 2. Install on Linux Operating Systems
There is no installation package for the Linux operating systems. You can just extract the OnData Encryption Tool package to a working folder and use the OnData 
Encryption Tool from a Linux Shell.  
  
## 3. Registration and Resource Access
If you have not registered your machine as an OnData client, you need to perform the client registration first. For details on how to register a OnData client, 
please refer to the [**OnData Client Registration**](reference_doc#securedb/database_drivers/ondata_client_registration). A copy of the OnData Configurator (**Configurator.exe** 
for Windows or **Configurator-{version_number}** for Linux) used for the registration is located in the installation folder of the OnData Encryption Tool, with the default 
path of \`C:/Program Files/OnData/OnData Encryption Tool/\` for Window. Also, you can launch the OnData Configurator from the Windows Start menu.  
  
Once your machine is registered as an OnData client, you need to grant resource access to that client. Navigate to \`Settings\` -> \`Organization\` -> \`Clients\`, 
and select \`Encryption Tool\` -> \`Active\`. Find the OnData client and click on the plus sign under \`Actions\`, select \`Assign Resources\` to assign databases and/or 
file templates that this client can have access to. For databases that have not been added to the OnData Portal yet, the OnData Encryption Tool will 
automatically assign them to itself when such databases are added to the OnData Portal using the OnData Encryption Tool.  
`
  
export default content;
